/**
 * Pin gate logic.
 * Calls onSuccess() when PIN accepted; otherwise shows inline error.
 */
import { ApiClient, AuthError, RateLimitError } from './api-client.js';

export function setupPinGate({ onSuccess }) {
  const overlay = document.getElementById('pin-gate');
  const form = document.getElementById('pin-form');
  const input = document.getElementById('pin-input');
  const error = document.getElementById('pin-error');
  const client = new ApiClient();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    error.classList.add('hidden');
    error.textContent = '';
    const pin = input.value.trim();
    if (!pin) return;
    try {
      await client.submitPIN(pin);
      overlay.classList.add('hidden');
      onSuccess();
    } catch (err) {
      if (err instanceof AuthError) error.textContent = 'Incorrect PIN. Try again.';
      else if (err instanceof RateLimitError) error.textContent = 'Too many attempts. Wait 10 minutes.';
      else error.textContent = 'Something went wrong. Refresh and try again.';
      error.classList.remove('hidden');
      input.value = '';
      input.focus();
    }
  });
}
